import catalog from './videoNpcCatalog.json';

export type CatalogNpcId = string;
export type CatalogDirectionId =
  | 'front'
  | 'three-quarter'
  | 'profile'
  | 'back-three-quarter'
  | 'back'
  | 'opposite-profile';
export type CatalogReactionId = 'positive' | 'negative';
export type CatalogBlockingAction = 'player-approach' | 'conversation' | 'group-talk' | 'crossing' | 'observing' | 'idle';

export interface CatalogClip {
  loop: boolean;
  src: string;
}

export interface CatalogDialogueChoice {
  id: string;
  label: string;
  playerLine: string;
  response: string;
  respectDelta: number;
  troubleDelta: number;
  rumorDelta: number;
}

export interface CatalogAssetMeasurement {
  canvasWidth: number;
  canvasHeight: number;
  opaqueBodyTopPx: number;
  opaqueBodyBottomPx: number;
}

export interface CatalogView extends CatalogAssetMeasurement {
  id: CatalogDirectionId;
  yawRadians: number;
  yawDegrees: number;
  src: string;
}

export interface CatalogReaction extends CatalogAssetMeasurement {
  id: CatalogReactionId;
  src: string;
}

export interface CatalogDefaults {
  position: [number, number, number];
  feet: [number, number];
  facingY: number;
  blockingRole: string;
  action: CatalogBlockingAction;
  scaleCorrection: number;
}

export interface CatalogNpc {
  id: CatalogNpcId;
  name: string;
  role: string;
  clique: string;
  bark: string;
  position: [number, number, number];
  heightMeters: number;
  accent: string;
  clips?: { idle: CatalogClip; react: CatalogClip };
  choices: CatalogDialogueChoice[];
  reactionByChoice: Record<string, CatalogReactionId>;
  defaults: CatalogDefaults;
  assets: {
    views: CatalogView[];
    reactions: Record<CatalogReactionId, CatalogReaction>;
  };
}

export interface NpcCatalog {
  schemaVersion: 1;
  npcs: CatalogNpc[];
}

export const NPC_CATALOG = catalog as unknown as NpcCatalog;
